import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-alert-confirmation',
  templateUrl: './alert-confirmation.component.html',
  styleUrls: ['./alert-confirmation.component.scss']
})
export class AlertConfirmationComponent implements OnInit {
  @Input() message: string;
  @Input() title: string;
  constructor(
    public dialogRef: MatDialogRef<AlertConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
   this.message = data === 'activate'? "Voulez-vous démarrer la promotion ?": "Voulez-vous arrêter la promotion ?";
    
  }

  ngOnInit() {
  }
  onNoClick(): void {
    this.dialogRef.close('NO');
  }
  onYesClick(){
    this.dialogRef.close('YES');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/alert-confirmation/alert-confirmation.component.ts